import { GoGrabber, GoX } from "react-icons/go";
import { MenuItem } from "./MenuItem";
import { routesData } from "../app/routesData";
import "./style.css";

export const FlatMenu = ({ isActive, handleToggle }) => {
    return (
      <>
        <ul className={`d-none ${isActive && `d-md-flex`} m-0 testing`}>
          {
            routesData.map((data, i) => {
              return (
                <li key={i} className="menu_obj navbar-brand mx-2">
                  <MenuItem path={data.path} desc={data.desc} handleToggle={null} />
                </li>
              );
            })
          }
        </ul>
        <button className={`menu__button nav_ac d-block ${isActive && `d-md-none`}`} onClick={handleToggle}>
          {isActive ? <GoGrabber /> : <GoX />}
        </button>
      </>
    );
  };